import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { VerificationServiceConfiguration } from "@idw-types/data/verification-service-configuration/verification-service-configuration";

type GetVerificationServiceConfigurationsRequestResponse = {
    rpserviceConfigs: Array<VerificationServiceConfiguration>;
};

export const getVerificationServiceConfigurationsRequest = async (
): Promise<{data: GetVerificationServiceConfigurationsRequestResponse, error: any }> => {
    const route = apiRoutes.serviceConfiguration.rpServiceConfig.rpServices;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};